import React, { useState, useEffect } from "react";
import ProductItem from "@entities/ProductItem";
import { ChatModal } from "@widgets/Chat";
import "../style/ProductWrapper.scss";
import { useMediaQuery } from "@shared/First";

const ProductWrapper = ({
  product,
  user,
  isEditing,
  registerForSave,
  activeWarehouseFilter,   // фильтр по складам
  activeInStockFilter,     // фильтр "только в наличии"
}) => {
  const isMobile = useMediaQuery("(max-width: 800px)");
  const [showChat, setShowChat] = useState(false);

  console.log("🔁 Render ProductWrapper", product._id, product.crm?.quantity);

  // локальные количества + резервы по складам
  const [quantities, setQuantities] = useState(() =>
    (product?.crm?.warehouse || []).reduce((acc, wh) => {
      acc[wh.id] = {
        quantity: Number(wh.quantity) || 0,
        reserve: Number(wh.reserve) || 0,
      };
      return acc;
    }, {})
  );

  // оригинальные значения для "Отмена"
  const [original, setOriginal] = useState(quantities);

  // при входе в режим редактирования — запоминаем "снимок"
  useEffect(() => {
    if (isEditing) setOriginal(quantities);
  }, [isEditing]); // eslint-disable-line react-hooks/exhaustive-deps

  // регистрируем себя в MainPage, отдаём геттер и ресет
  useEffect(() => {
    registerForSave(product, {
      getQuantities: () => quantities,
      reset: () => setQuantities(original),
    });
  }, [product, quantities, original, registerForSave]);

  // обновляем state при смене product
  useEffect(() => {
    const initial = (product?.crm?.warehouse || []).reduce((acc, wh) => {
      acc[wh.id] = {
        quantity: Number(wh.quantity) || 0,
        reserve: Number(wh.reserve) || 0,
      };
      return acc;
    }, {});
    setQuantities(initial);
    setOriginal(initial);
  }, [product]);

  // только цифры в input
  const handleQuantityChange = (warehouseId, val) => {
    if (/^\d*$/.test(val)) {
      setQuantities((prev) => ({
        ...prev,
        [warehouseId]: {
          ...prev[warehouseId],
          quantity: val === "" ? 0 : Number(val),
        },
      }));
    }
  };

  // сортируем склады по ID
  let sortedWarehouses = Array.isArray(product?.crm?.warehouse)
    ? [...product.crm.warehouse].sort((a, b) => a.id - b.id)
    : [];

  // если выбран фильтр по складу → оставляем только выбранные
  if (activeWarehouseFilter && activeWarehouseFilter.length > 0) {
    const allowedIds = activeWarehouseFilter.map((f) => String(f.value));
    sortedWarehouses = sortedWarehouses.filter((wh) =>
      allowedIds.includes(String(wh.id))
    );
  }

  return (
    <div className="product-wrapper">
      <div className="product-wrapper__item">
        <ProductItem
          {...product}
          product={product}
          onChatClick={() => setShowChat(true)}
        />
      </div>

      <div className="product-wrapper__warehouses">
        {sortedWarehouses.map((wh) => {
          const q = quantities[wh.id]?.quantity ?? 0;
          const r = quantities[wh.id]?.reserve ?? 0;
          const available = q - r;

          // подсветка при активных фильтрах и наличии остатка
          const highlight =
            (activeInStockFilter || activeWarehouseFilter) && available > 0;

          return (
            <div className="warehouse-col" key={wh.id}>
              {isMobile && (
                <div className="warehouse-col__title">{wh.name}</div>
              )}
              <div
                className={`warehouse-col__values 
                  ${isEditing ? "is-editing" : ""} 
                  ${highlight ? "warehouse-col--highlight" : ""}`}
              >
                <input
                  className="cell-input"
                  type="text"
                  value={q}
                  onChange={(e) => handleQuantityChange(wh.id, e.target.value)}
                  disabled={!isEditing}
                />
                <input
                  className="cell-input"
                  type="text"
                  value={r}
                  disabled
                />
                <input
                  className="cell-input avaliable"
                  type="text"
                  value={available}
                  disabled
                />
              </div>
            </div>
          );
        })}
      </div>

      {showChat && (
        <ChatModal
          product={product}
          user={user}
          onClose={() => setShowChat(false)}
        />
      )}
    </div>
  );
};

export default ProductWrapper;
